export const plans = [
  {
    name: "small_business",
    link: "small-business",
    price: 39,
    title: "Small Business",
    subtitle: "Ideal for growing businesses with a small fleet.",
    value: 1,
    trial: true
  },
  {
    name: "business",
    link: "business",
    price: 59,
    title: "Business",
    subtitle:
      "Ideal for businesses that need proof of delivery and access to pro features.",
    value: 2
  }
];
